import { render, staticRenderFns } from "./ViewDatabaseDialog.vue?vue&type=template&id=b6d18974&"
import script from "./ViewDatabaseDialog.vue?vue&type=script&lang=ts&"
export * from "./ViewDatabaseDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports